<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 33 33"
        class="fill-current"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.4565 5.53662V6.78662L20.4565 6.78662V5.53662H22.4565V6.78662H24.9565C26.0611 6.78662 26.9565 7.68205 26.9565 8.78662V24.7866C26.9565 25.8912 26.0611 26.7866 24.9565 26.7866H8.95654C7.85197 26.7866 6.95654 25.8912 6.95654 24.7866V8.78662C6.95654 7.68205 7.85197 6.78662 8.95654 6.78662H11.4565V5.53662H13.4565ZM20.4565 8.78662V10.0366H22.4565V8.78662H24.9565V11.2358H8.95654V8.78662H11.4565V10.0366H13.4565V8.78662L20.4565 8.78662ZM24.9565 13.2358V24.7866H8.95654L8.95654 13.2358H24.9565Z"
        />
    </svg>
</template>
